import { EntityContext } from 'nekst-api';
import { ChatMessage } from './types';

interface TransferState {
  conversationId: number;
  messages: ChatMessage[];
  streamingText: string;
  isStreaming: boolean;
  selectedContext: EntityContext[];
}

let pendingTransfer: TransferState | null = null;

export function setTransferState(state: TransferState) {
  pendingTransfer = state;
}

export function consumeTransferState(conversationId: number): TransferState | null {
  if (pendingTransfer && pendingTransfer.conversationId === conversationId) {
    const state = pendingTransfer;
    pendingTransfer = null;
    return state;
  }
  return null;
}

export function clearTransferState() {
  pendingTransfer = null;
}
